import { render, staticRenderFns } from "./enamadFailed.vue?vue&type=template&id=472939d2&"
import script from "./enamadFailed.vue?vue&type=script&lang=js&"
export * from "./enamadFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports